module.exports = __webpack_public_path__ + "img/undTooth6.c341a5de.png";